import { List } from 'immutable';
import ConcernsStudentSKill from './model';
import StudentGeneralInfo from '../StudentGeneralInfo';
import SkillScore from '../SkillScore';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'groupId':
    case 'groupCode':
      return [key, `${val}`];  // stringify
    case 'studentGeneralInfo':
      return [key, StudentGeneralInfo.create(val)];
    case 'skillScores':
      return [key, new List(val.map((skillScore) => SkillScore.create(skillScore)))];
    default:
      return [key, val];
  }
};

const create = (data) => new ConcernsStudentSKill(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/AcademicInfo/ConcernsStudentSkill/create.js